import React, { useEffect, useState } from "react";
import axios from "axios";

const LabelsTable = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("http://localhost:8000/excel/get-excel"); 
        setData(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>All Excel Data</h2>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "20px",
        }}
      >
        <thead>
          <tr>
            <th style={{ border: "1px solid #000", padding: "8px" }}>ID</th>
            <th style={{ border: "1px solid #000", padding: "8px" }}>Name</th>
            <th style={{ border: "1px solid #000", padding: "8px" }}>Phone</th>
            <th style={{ border: "1px solid #000", padding: "8px" }}>Address</th>
            <th style={{ border: "1px solid #000", padding: "8px" }}>City</th>
            <th style={{ border: "1px solid #000", padding: "8px" }}>State</th>
            <th style={{ border: "1px solid #000", padding: "8px" }}>PinCode</th>
            <th style={{ border: "1px solid #000", padding: "8px" }}>Hampers</th>
            <th style={{ border: "1px solid #000", padding: "8px" }}>Client Name</th>
            <th style={{ border: "1px solid #000", padding: "8px" }}>Client Address</th>
            {/* <th style={{ border: "1px solid #000", padding: "8px" }}>Printed?</th> */}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id}>
              <td style={{ border: "1px solid #000", padding: "8px" }}>{row.id}</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>{row.name}</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>{row.phoneNo}</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>{row.address}</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>{row.city}</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>{row.state}</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>{row.pinCode}</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>{row.hampers}</td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>
                {row.ClientData?.clientName || "-"}
              </td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>
                {row.ClientData?.clientAddress || "-"}
              </td>
              {/* <td style={{ border: "1px solid #000", padding: "8px" }}>
                {row.isPrinted ? "Yes" : "No"}
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LabelsTable;
